// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.main-setting .tab-box {
    width: 100%;
    margin-top: 20px;
    /*border-top: 2px solid #D9D9D9;*/
}

.tab-box ul {
    /* display: flex;
    width: 100%;
    align-items: center;
    justify-content: center; */
    text-align: center;
    white-space: nowrap;
}

.main-setting .tab-box::-webkit-scrollbar {
    height: 7px;
}

.tab-box ul li {
    list-style: none;
    /* font-weight: 500; */
    font-size: 18px;
    padding: 8px 0;
    margin: 0px 25px;
    color: #8E8E8E;
    cursor: pointer;
    display: inline-block;
    white-space: nowrap;
}

.tab-box ul li.active {
    border-top: 3px solid #6c2fbb;
    color: #6c2fbb;
}

.tab-box ul li.active svg path {
    fill: #6c2fbb !important;
}

.tab-content h2 {
    font-weight: 400;
    font-size: 22px;
    color: #0f062b;
    padding: 5px 0 20px;
    margin-bottom: 0;
}
.acc-status{
    color: red !important;
}

.profile-box {
    width: 100%;
    margin-top: 40px;
    padding: 20px;
    display: flex;
    align-items: center;
    border-radius: 13px;
    background-color: #fff;
}
.magic-btn {
   background-color: #e3d7f9 !important;
    width: 24px !important;
    height: 24px !important;;
} 
.magic-btn img {
     width: 25px !important;
    height: 25px !important;
}
.profile-box .user-edit .icon-group button {
    width: 27px;
    height: 27px;
    background: transparent;
    border-radius: 6px;
    border: none;
    padding: 0;
    overflow: hidden;
}
.profile-box .user-edit .icon-group {
    display: flex;
    align-items: center;
    gap: 2px;
}

.profile-box .user-img {
    /*width: 83px;
    height: 83px;*/
    width: 70px;
    height: 70px;
    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
    border-radius: 13px;
    position: relative;
}

.profile-box .user-edit input {
    opacity: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    cursor: pointer;
    position: absolute;
    z-index: 9;
}

#imageGenerateModal p{
    font-size: 12px;
    color: #8d8d8d;
}

::ng-deep .user-prompt-modal .mat-mdc-dialog-surface{
    padding: 0 !important;
}

.profile-box .user-img img {
    width: 100%;
    height: 100%;
    border-radius: 13px;
}

.profile-box .profile-content {
    margin-left: 10px;
}

.profile-box .profile-content h4 {
    font-weight: 400;
    margin: 0px 0px 8px 0px;
    font-size: 18px;
    color: #0F062B;
}

.profile-box .profile-content p {
    color: rgba(136, 133, 142, 1);
    font-size: 14px;
    margin-bottom: 0;
    /*font-size: 17px;*/

}

.account-detail {
    margin: 50px 0;

}

.account-detail .form {
    padding: 15px;
    border-radius: 13px;
    background-color: #fff;
}

.account-detail .input-box {
    display: flex;
    align-items: center;
    margin: 10px 0;


}

.account-detail .input-box label {
    font-size: 16px;
    font-weight: 400;
    color: #0F062B;
    width: 115px;
    text-align: right;
    min-width: 115px;
    white-space: nowrap;
    margin-right: 15px;
    margin-bottom: 0;
}

.account-detail .input-box input, .account-detail .input-box textarea {
    width: 100%;
    padding: 10px 20px;
    border: 1px solid #fff;
    outline: none;
    background-color: #F9F8FB;
    border-radius: 8px;
    font-size: 16px;
}

.bottom-con {
    display: flex;
    justify-content: space-between;
    margin-left: 130px;
    color: rgba(136, 133, 142, 1);
}

.submit-btn {
    background: #6c2fbb;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    padding: 10px 35px;
    gap: 10px;
    white-space: nowrap;
    border-radius: 8px;
    border: none;
    display: flex;
    margin-left: auto;
}


.subscription-box {
    padding: 20px;
    border-radius: 13px;
    background-color: #ffff;
}

.subscription-box .dis {
    color: rgba(104, 104, 104, 1);
}

.subscription-box .update-dis {
    display: flex;
    justify-content: space-between;
}

.subscription-box .update {
    color: #6c2fbb;
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 0;
    cursor: pointer;
    text-decoration: none;
}

.subscription-box .plan {
    display: flex;
    /*flex-wrap: wrap;*/
    /* align-items: center; */
}

.subscription-box .plan label {
    width: 150px;
    min-width: 150px;
    font-weight: 400;
    text-align: right;
    font-size: 16px;
    margin-right: 25px;
    margin-bottom: 0;
}

.subscription-box .plan .line {
    width: 500px;
    height: 1px;
    margin: 12px 0;
    background-color: #929292;
}

.line-two {
    width: 100%;
    height: 1px;
    margin: 6px 0;
    background-color: #929292;
}


.subscription-box .plan p {
    color: rgba(73, 73, 73, 1);
    font-size: 16px;
    text-transform: capitalize;
    margin-bottom: 0;
    white-space: nowrap;

}

.subscription-box .plan h5 {
    color: rgba(73, 73, 73, 1);
    font-size: 16px;
    font-weight:400;
    margin: 0;

}

.area-box .interest-box button {
    color: #6c2fbb;
    border: 1px solid #6c2fbb;
    padding: 5px 15px;
    font-size: 14px;
    font-weight: 400;
    background: #FFFFFF;
    border-radius: 13px;
    margin: 10px 7px;
    /*white-space: nowrap;*/
}


.subscription-box .pass-detail {
    display: flex;
    width: 100%;
    justify-content: space-between;
}

.subscription-box .pass-detail .link-button {
    color: #6c2fbb;
    font-weight: 400;
    font-size: 16px;
    padding: 0;
    text-decoration: none;
}

.subscription-box .pass-detail .cancel-button {
    color: red;
    font-weight: 400;
    font-size: 16px;
    padding: 0;
    text-decoration: none;
}

.video-common-btn {
    width: auto;
    /* margin-left: -15px; */
}

.generate-img {
    width: 100%;
    height: 400px;
    border: 1px solid #e7e7e7;
    border-radius: 10px;
    padding: 10px;
}
.generate-img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

@media (max-width: 1300px) {
    .tab-box ul li {
        font-size: 18px;
    }

    .tab-content h2 {
        font-size: 22px;
        padding: 5px 0 12px;
    }

    .profile-box .profile-content h4 {
        font-size: 18px;
    }

    .profile-box .profile-content p {
        font-size: 14px;
    }

    .subscription-box .pass-detail .link-button {
        font-size: 15px;
        white-space: nowrap;
        text-align: start;

    }

    .subscription-box .plan input {
        width: 70%;
    }

    .subscription-box .update {
        font-size: 15px;
        text-align: start;
    }

}

@media (max-width: 991px) {
    .tab-content h2 {
        font-size: 22px;
    }

    .profile-box .profile-content h4 {
        font-size: 18px;
    }

    .profile-box .profile-content p {
        font-size: 16px;
    }

    .profile-box,
    .account-detail .form {
        padding: 10px;
    }

    .subscription-box {
        padding: 10px;
    }

    .area-box .plan button {
        padding: 10px 25px;
        font-size: 16px;
    }
}

@media (max-width: 768px) {
    .account-detail .input-box label {
        font-size: 17px;
    }

    .main-setting .tab-box {

        overflow-x: auto;
    }

    .account-detail .input-box {
        flex-direction: column;
        align-items: flex-start;
    }

    .account-detail .input-box label {
        text-align: start;
    }

    .bottom-con {
        margin-left: 0;
    }

    .account-detail {
        margin: 30px 0;
    }

    .tab-box ul li {
        font-size: 18px;
    }


    .subscription-box .plan {
        flex-direction: column;
    }

    .subscription-box .plan label {
        text-align: start;
    }

    .area-box .plan button {
        width: 200px;
        margin: 10px 0;
        padding: 10px 0;
    }

    .subscription-box .plan .line {
        width: auto;
    }

    .subscription-box .plan p {
        font-size: 15px;
    }

}

@media (max-width: 520px) {
    .profile-box {
        flex-direction: column;
        text-align: center;
    }

    .profile-box .profile-content {
        margin-top: 10px;
    }

    .tab-content h2 {
        font-size: 20px;
    }

    .account-detail .input-box label {
        font-size: 16px;
    }

    .bottom-con p {
        font-size: 14px;
    }

    .subscription-box .plan label {
        font-size: 16px;
    }

    .subscription-box .dis {
        font-size: 16px;
    }

    .subscription-box .pass-detail {
        flex-direction: column;
    }


    .account-detail .input-box input {
        padding: 8px 12px;
    }

    .profile-box .profile-content h4 {
        margin-top: 8px;
    }

    .interest-box label {
        width: 100%;
    }

    .area-box .interest-box button {
        padding: 5px 15px;
        font-size: 14px;
    }

    .subscription-box .update-dis {
        flex-direction: column;
    }
}

.tab-content {
    display: none;
}

.active-tab {
    display: block;
}


/* tab two style ======== */
.public-profile .heading h2 {
    margin-top:40px;
    font-size: 20px;
    font-weight: 400;
    padding-bottom: 0;
}

.public-profile .heading p {
    color: #88858E;
    margin-top: 8px;
}

.upload-vid-box {
    width: 100%;
    background-color: #ffff;
    padding: 20px;
    margin-bottom: 20px;
    border-radius: 13px;
    margin-top: 20px !important
}

@media (max-width: 768px) {
    .upload-vid-box {
        padding: 8px;
    }

    input:checked + .slider:before {
        transform: translateX(19px);
    }

    .public-content-box h5 {
        font-size: 18px;
    }
}

.signup-group {
    margin-bottom: 15px;
    position: relative;
}

form .signup-group .txtarea .input-field {
    bottom: auto;
    top: 18px;
}

form .signup-group .txtarea textarea {
    padding-top: 15px;
}

form .signup-group .txtarea .input-field.video_input_focus {
    bottom: auto !important;
    top: 5px !important;
}

.btn-show-password {
    position: absolute;
    text-decoration: none;
    color: #6c2fbb;
    right: 0;
    top: 0;
}

.btn-show-new-password {
    position: absolute;
    text-decoration: none;
    color: #6c2fbb;
    right: 0;
    top: 0;
}

.btn-show-cnew-password {
    position: absolute;
    text-decoration: none;
    color: #6c2fbb;
    right: 0;
    top: 0;
}


custom-toggle-switch::before {
    background-color: #6c2fbb;
}

.custom-switch.custom-switch-lg p,
.custom-switch.custom-switch-lg .custom-control-label {
    padding-left: 3rem;
}

.custom-switch.custom-switch-lg p {
    color: #88858E;
}

.custom-switch.custom-switch-lg .custom-control-label::before {
    height: 1.7rem;
    width: calc(3rem + 0.75rem);
    cursor: pointer;
    border-radius: 4rem;
}

.custom-switch.custom-switch-lg .custom-control-label::after {
    width: calc(2rem - 7px);
    height: calc(1.7rem - 4px);
    border-radius: calc(3rem - (2rem / 2));
    box-shadow: 25px 25px 27px -9px rgba(133, 133, 133, 1);
}

.custom-switch.custom-switch-lg .custom-control-input:checked ~ .custom-control-label::after {
    transform: translateX(calc(2.1rem - 0.1rem));
}

#user_bio::-webkit-scrollbar {
    width: 6px;
}
#user_bio::-webkit-scrollbar-thumb {
    background: #ebebed;
    border-radius: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/app/afterLogin/settings/settings.component.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI;;;8BAG0B;IAC1B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;GACG,oCAAoC;IACnC,sBAAsB;IACtB,uBAAuB;AAC3B;AACA;KACK,sBAAsB;IACvB,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI;kBACc;IACd,WAAW;IACX,YAAY;IAGZ,sDAAsD;IACtD,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;;;AAGlB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iBAAiB;AACrB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;;AAGA;IACI,0BAA0B;IAC1B,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;IACf,eAAe;IACf,SAAS;;AAEb;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;;AAGA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,mBAAmB;QACnB,iBAAiB;;IAErB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;AAEJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;QACZ,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;;IAGA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;;AAGA,2BAA2B;AAC3B;IACI,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QAGI,2BAA2B;IAC/B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,QAAQ;IACR,MAAM;AACV;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,sCAAsC;IAGtC,sDAAsD;AAC1D;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,UAAU;AACd;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":["\n.main-setting .tab-box {\n    width: 100%;\n    margin-top: 20px;\n    /*border-top: 2px solid #D9D9D9;*/\n}\n\n.tab-box ul {\n    /* display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center; */\n    text-align: center;\n    white-space: nowrap;\n}\n\n.main-setting .tab-box::-webkit-scrollbar {\n    height: 7px;\n}\n\n.tab-box ul li {\n    list-style: none;\n    /* font-weight: 500; */\n    font-size: 18px;\n    padding: 8px 0;\n    margin: 0px 25px;\n    color: #8E8E8E;\n    cursor: pointer;\n    display: inline-block;\n    white-space: nowrap;\n}\n\n.tab-box ul li.active {\n    border-top: 3px solid #6c2fbb;\n    color: #6c2fbb;\n}\n\n.tab-box ul li.active svg path {\n    fill: #6c2fbb !important;\n}\n\n.tab-content h2 {\n    font-weight: 400;\n    font-size: 22px;\n    color: #0f062b;\n    padding: 5px 0 20px;\n    margin-bottom: 0;\n}\n.acc-status{\n    color: red !important;\n}\n\n.profile-box {\n    width: 100%;\n    margin-top: 40px;\n    padding: 20px;\n    display: flex;\n    align-items: center;\n    border-radius: 13px;\n    background-color: #fff;\n}\n.magic-btn {\n   background-color: #e3d7f9 !important;\n    width: 24px !important;\n    height: 24px !important;;\n} \n.magic-btn img {\n     width: 25px !important;\n    height: 25px !important;\n}\n.profile-box .user-edit .icon-group button {\n    width: 27px;\n    height: 27px;\n    background: transparent;\n    border-radius: 6px;\n    border: none;\n    padding: 0;\n    overflow: hidden;\n}\n.profile-box .user-edit .icon-group {\n    display: flex;\n    align-items: center;\n    gap: 2px;\n}\n\n.profile-box .user-img {\n    /*width: 83px;\n    height: 83px;*/\n    width: 70px;\n    height: 70px;\n    -webkit-box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;\n    -moz-box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;\n    box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;\n    border-radius: 13px;\n    position: relative;\n}\n\n.profile-box .user-edit input {\n    opacity: 0;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    cursor: pointer;\n    position: absolute;\n    z-index: 9;\n}\n\n#imageGenerateModal p{\n    font-size: 12px;\n    color: #8d8d8d;\n}\n\n::ng-deep .user-prompt-modal .mat-mdc-dialog-surface{\n    padding: 0 !important;\n}\n\n.profile-box .user-img img {\n    width: 100%;\n    height: 100%;\n    border-radius: 13px;\n}\n\n.profile-box .profile-content {\n    margin-left: 10px;\n}\n\n.profile-box .profile-content h4 {\n    font-weight: 400;\n    margin: 0px 0px 8px 0px;\n    font-size: 18px;\n    color: #0F062B;\n}\n\n.profile-box .profile-content p {\n    color: rgba(136, 133, 142, 1);\n    font-size: 14px;\n    margin-bottom: 0;\n    /*font-size: 17px;*/\n\n}\n\n.account-detail {\n    margin: 50px 0;\n\n}\n\n.account-detail .form {\n    padding: 15px;\n    border-radius: 13px;\n    background-color: #fff;\n}\n\n.account-detail .input-box {\n    display: flex;\n    align-items: center;\n    margin: 10px 0;\n\n\n}\n\n.account-detail .input-box label {\n    font-size: 16px;\n    font-weight: 400;\n    color: #0F062B;\n    width: 115px;\n    text-align: right;\n    min-width: 115px;\n    white-space: nowrap;\n    margin-right: 15px;\n    margin-bottom: 0;\n}\n\n.account-detail .input-box input, .account-detail .input-box textarea {\n    width: 100%;\n    padding: 10px 20px;\n    border: 1px solid #fff;\n    outline: none;\n    background-color: #F9F8FB;\n    border-radius: 8px;\n    font-size: 16px;\n}\n\n.bottom-con {\n    display: flex;\n    justify-content: space-between;\n    margin-left: 130px;\n    color: rgba(136, 133, 142, 1);\n}\n\n.submit-btn {\n    background: #6c2fbb;\n    font-weight: 400;\n    font-size: 14px;\n    color: #ffffff;\n    padding: 10px 35px;\n    gap: 10px;\n    white-space: nowrap;\n    border-radius: 8px;\n    border: none;\n    display: flex;\n    margin-left: auto;\n}\n\n\n.subscription-box {\n    padding: 20px;\n    border-radius: 13px;\n    background-color: #ffff;\n}\n\n.subscription-box .dis {\n    color: rgba(104, 104, 104, 1);\n}\n\n.subscription-box .update-dis {\n    display: flex;\n    justify-content: space-between;\n}\n\n.subscription-box .update {\n    color: #6c2fbb;\n    font-weight: 400;\n    font-size: 16px;\n    margin-bottom: 0;\n    cursor: pointer;\n    text-decoration: none;\n}\n\n.subscription-box .plan {\n    display: flex;\n    /*flex-wrap: wrap;*/\n    /* align-items: center; */\n}\n\n.subscription-box .plan label {\n    width: 150px;\n    min-width: 150px;\n    font-weight: 400;\n    text-align: right;\n    font-size: 16px;\n    margin-right: 25px;\n    margin-bottom: 0;\n}\n\n.subscription-box .plan .line {\n    width: 500px;\n    height: 1px;\n    margin: 12px 0;\n    background-color: #929292;\n}\n\n.line-two {\n    width: 100%;\n    height: 1px;\n    margin: 6px 0;\n    background-color: #929292;\n}\n\n\n.subscription-box .plan p {\n    color: rgba(73, 73, 73, 1);\n    font-size: 16px;\n    text-transform: capitalize;\n    margin-bottom: 0;\n    white-space: nowrap;\n\n}\n\n.subscription-box .plan h5 {\n    color: rgba(73, 73, 73, 1);\n    font-size: 16px;\n    font-weight:400;\n    margin: 0;\n\n}\n\n.area-box .interest-box button {\n    color: #6c2fbb;\n    border: 1px solid #6c2fbb;\n    padding: 5px 15px;\n    font-size: 14px;\n    font-weight: 400;\n    background: #FFFFFF;\n    border-radius: 13px;\n    margin: 10px 7px;\n    /*white-space: nowrap;*/\n}\n\n\n.subscription-box .pass-detail {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.subscription-box .pass-detail .link-button {\n    color: #6c2fbb;\n    font-weight: 400;\n    font-size: 16px;\n    padding: 0;\n    text-decoration: none;\n}\n\n.subscription-box .pass-detail .cancel-button {\n    color: red;\n    font-weight: 400;\n    font-size: 16px;\n    padding: 0;\n    text-decoration: none;\n}\n\n.video-common-btn {\n    width: auto;\n    /* margin-left: -15px; */\n}\n\n.generate-img {\n    width: 100%;\n    height: 400px;\n    border: 1px solid #e7e7e7;\n    border-radius: 10px;\n    padding: 10px;\n}\n.generate-img img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n}\n\n@media (max-width: 1300px) {\n    .tab-box ul li {\n        font-size: 18px;\n    }\n\n    .tab-content h2 {\n        font-size: 22px;\n        padding: 5px 0 12px;\n    }\n\n    .profile-box .profile-content h4 {\n        font-size: 18px;\n    }\n\n    .profile-box .profile-content p {\n        font-size: 14px;\n    }\n\n    .subscription-box .pass-detail .link-button {\n        font-size: 15px;\n        white-space: nowrap;\n        text-align: start;\n\n    }\n\n    .subscription-box .plan input {\n        width: 70%;\n    }\n\n    .subscription-box .update {\n        font-size: 15px;\n        text-align: start;\n    }\n\n}\n\n@media (max-width: 991px) {\n    .tab-content h2 {\n        font-size: 22px;\n    }\n\n    .profile-box .profile-content h4 {\n        font-size: 18px;\n    }\n\n    .profile-box .profile-content p {\n        font-size: 16px;\n    }\n\n    .profile-box,\n    .account-detail .form {\n        padding: 10px;\n    }\n\n    .subscription-box {\n        padding: 10px;\n    }\n\n    .area-box .plan button {\n        padding: 10px 25px;\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 768px) {\n    .account-detail .input-box label {\n        font-size: 17px;\n    }\n\n    .main-setting .tab-box {\n\n        overflow-x: auto;\n    }\n\n    .account-detail .input-box {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .account-detail .input-box label {\n        text-align: start;\n    }\n\n    .bottom-con {\n        margin-left: 0;\n    }\n\n    .account-detail {\n        margin: 30px 0;\n    }\n\n    .tab-box ul li {\n        font-size: 18px;\n    }\n\n\n    .subscription-box .plan {\n        flex-direction: column;\n    }\n\n    .subscription-box .plan label {\n        text-align: start;\n    }\n\n    .area-box .plan button {\n        width: 200px;\n        margin: 10px 0;\n        padding: 10px 0;\n    }\n\n    .subscription-box .plan .line {\n        width: auto;\n    }\n\n    .subscription-box .plan p {\n        font-size: 15px;\n    }\n\n}\n\n@media (max-width: 520px) {\n    .profile-box {\n        flex-direction: column;\n        text-align: center;\n    }\n\n    .profile-box .profile-content {\n        margin-top: 10px;\n    }\n\n    .tab-content h2 {\n        font-size: 20px;\n    }\n\n    .account-detail .input-box label {\n        font-size: 16px;\n    }\n\n    .bottom-con p {\n        font-size: 14px;\n    }\n\n    .subscription-box .plan label {\n        font-size: 16px;\n    }\n\n    .subscription-box .dis {\n        font-size: 16px;\n    }\n\n    .subscription-box .pass-detail {\n        flex-direction: column;\n    }\n\n\n    .account-detail .input-box input {\n        padding: 8px 12px;\n    }\n\n    .profile-box .profile-content h4 {\n        margin-top: 8px;\n    }\n\n    .interest-box label {\n        width: 100%;\n    }\n\n    .area-box .interest-box button {\n        padding: 5px 15px;\n        font-size: 14px;\n    }\n\n    .subscription-box .update-dis {\n        flex-direction: column;\n    }\n}\n\n.tab-content {\n    display: none;\n}\n\n.active-tab {\n    display: block;\n}\n\n\n/* tab two style ======== */\n.public-profile .heading h2 {\n    margin-top:40px;\n    font-size: 20px;\n    font-weight: 400;\n    padding-bottom: 0;\n}\n\n.public-profile .heading p {\n    color: #88858E;\n    margin-top: 8px;\n}\n\n.upload-vid-box {\n    width: 100%;\n    background-color: #ffff;\n    padding: 20px;\n    margin-bottom: 20px;\n    border-radius: 13px;\n    margin-top: 20px !important\n}\n\n@media (max-width: 768px) {\n    .upload-vid-box {\n        padding: 8px;\n    }\n\n    input:checked + .slider:before {\n        -webkit-transform: translateX(19px);\n        -ms-transform: translateX(19px);\n        transform: translateX(19px);\n    }\n\n    .public-content-box h5 {\n        font-size: 18px;\n    }\n}\n\n.signup-group {\n    margin-bottom: 15px;\n    position: relative;\n}\n\nform .signup-group .txtarea .input-field {\n    bottom: auto;\n    top: 18px;\n}\n\nform .signup-group .txtarea textarea {\n    padding-top: 15px;\n}\n\nform .signup-group .txtarea .input-field.video_input_focus {\n    bottom: auto !important;\n    top: 5px !important;\n}\n\n.btn-show-password {\n    position: absolute;\n    text-decoration: none;\n    color: #6c2fbb;\n    right: 0;\n    top: 0;\n}\n\n.btn-show-new-password {\n    position: absolute;\n    text-decoration: none;\n    color: #6c2fbb;\n    right: 0;\n    top: 0;\n}\n\n.btn-show-cnew-password {\n    position: absolute;\n    text-decoration: none;\n    color: #6c2fbb;\n    right: 0;\n    top: 0;\n}\n\n\ncustom-toggle-switch::before {\n    background-color: #6c2fbb;\n}\n\n.custom-switch.custom-switch-lg p,\n.custom-switch.custom-switch-lg .custom-control-label {\n    padding-left: 3rem;\n}\n\n.custom-switch.custom-switch-lg p {\n    color: #88858E;\n}\n\n.custom-switch.custom-switch-lg .custom-control-label::before {\n    height: 1.7rem;\n    width: calc(3rem + 0.75rem);\n    cursor: pointer;\n    border-radius: 4rem;\n}\n\n.custom-switch.custom-switch-lg .custom-control-label::after {\n    width: calc(2rem - 7px);\n    height: calc(1.7rem - 4px);\n    border-radius: calc(3rem - (2rem / 2));\n    -webkit-box-shadow: 25px 25px 27px -9px rgba(133, 133, 133, 1);\n    -moz-box-shadow: 25px 25px 27px -9px rgba(133, 133, 133, 1);\n    box-shadow: 25px 25px 27px -9px rgba(133, 133, 133, 1);\n}\n\n.custom-switch.custom-switch-lg .custom-control-input:checked ~ .custom-control-label::after {\n    transform: translateX(calc(2.1rem - 0.1rem));\n}\n\n#user_bio::-webkit-scrollbar {\n    width: 6px;\n}\n#user_bio::-webkit-scrollbar-thumb {\n    background: #ebebed;\n    border-radius: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
